<!-- Header -->
<h1 mat-dialog-title>{{ config.title }}</h1>

<!-- Content -->
<div mat-dialog-content>
  <mat-form-field>
    
    <!-- Input -->
    <input #valueInput matInput *ngIf="!config.textarea"
    [(ngModel)]="config.value" 
    [ngModelOptions]="{ standalone: true }"
    placeholder="{{ 'value' | translate }}"
    (keydown.enter)="submit()"
    cdkFocusInitial/>

    <!-- Textarea -->
    <textarea matInput *ngIf="config.textarea"
    [(ngModel)]="config.value" 
    [ngModelOptions]="{ standalone: true }"
    placeholder="{{ 'value' | translate }}"
    cdkFocusInitial>
    </textarea>

  </mat-form-field>
</div>

<!-- Actions -->
<div mat-dialog-actions align="end">

  <button mat-button tabindex="-1" (click)="cancel()">
    {{ 'cancel' | translate }}
  </button>
  
  <button mat-flat-button (click)="submit()" tabindex="-1" [color]="'primary'">
    <mat-icon>save</mat-icon>
    {{ 'save' | translate }}
  </button>

</div>
